import { render } from "./EmailChangeDialog.vue?vue&type=template&id=d9359996"
import script from "./EmailChangeDialog.vue?vue&type=script&lang=js"
export * from "./EmailChangeDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__